<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div class="col-md-4">
        <z-input
          v-model="firstname"
          name="firstname"
          label="First Name"
          validate="required"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-4">
        <z-input
          v-model="lastname"
          name="lastname"
          label="Last Name"
          validate="required"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-4">
        <z-input
          v-model="nickname"
          name="nickname"
          label="Nickname"
          @keyup="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <z-input
          v-model="email"
          name="email"
          label="Email (username)"
          type="email"
          validate="required"
          @blur="checkIt"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-4">
        <i v-if="emailOkay" class="fas fa-check custom-email-okay"></i>
        <span v-if="foundEmail" class="custom-email-exists"
          >Email address already exists!</span
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <z-select
          v-model="gender"
          :options="genders"
          label="Gender"
          @change="changeGender"
        />
      </div>
      <div class="col-md-4">
        <z-input
          v-model="birthday"
          name="birthday"
          label="Birthday"
          type="date"
          @change="saveIt"
        />
      </div>
      <div class="col-md-4"></div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="form-label" for="userEid">User Eid:</label>
        <span id="userEid" class="custom-id">{{ eid }}</span>
      </div>
      <div class="col-md-6"></div>
    </div>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import globals from '@/Plugins/globals'
export default {
  name: 'user-basic',
  components: {
    ZInput,
    ZSelect,
  },
  props: {
    isAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      foundEmail: false,
      emailOkay: false,
      genders: [
        {
          id: 1,
          name: 'Male',
          value: 'Male',
        },
        {
          id: 2,
          name: 'Female',
          value: 'Female',
        },
        {
          id: 3,
          name: 'Other',
          value: 'Other',
        },
      ],
    }
  },
  emits: ['saveIt', 'emailFound'],
  computed: {
    ...mapGetters('users', ['user']),
    id() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.id
      }
      return _data
    },
    eid() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.eid
      }
      return _data
    },
    firstname: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.firstName
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'firstname',
          value: value,
        })
      },
    },
    lastname: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.lastName
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'lastname',
          value: value,
        })
      },
    },
    nickname: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.nickName
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'nickname',
          value: value,
        })
      },
    },
    email: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.email
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'email',
          value: value,
        })
      },
    },
    gender: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.gender
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'gender',
          value: value,
        })
      },
    },
    birthday: {
      get() {
        let _data = null
        if (this.user) {
          _data = globals.formatDate(this.user.detail.birthday, 'dateYMD')
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'birthday',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('users', ['setUserData', 'checkForExisting']),
    async checkIt() {
      this.foundEmail = false
      this.emailOkay = false
      if (this.isAdd) {
        let data = {
          email: this.user.detail.email,
        }
        let result = await this.checkForExisting(data)
        if (result) {
          console.log('User Exist?', result)
          if (result.found) {
            this.foundEmail = true
            this.emailOkay = false
            this.$emit('emailFound')
          } else {
            this.emailOkay = true
          }
        }
      }
    },
    saveIt() {
      this.$emit('saveIt')
    },
    changeGender() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style scoped>
.custom-id {
  padding-left: 5px;
}
.custom-email-okay {
  color: green;
  font-size: 1.5em;
  position: relative;
  top: 28px;
}
.custom-email-exists {
  font-weight: 600;
  color: red;
  top: 28px;
  position: relative;
}
</style>
